export const contactInfo = {
  whatsapp: "+6287870082806", // Nomor utama untuk WhatsApp redirect
  name: "Fera Farfalla",
  phone: "+6287870082806",
  address: "Bukit Asri Ciomas Blok E4 No.14, Jalan Dahlia",
};

export const heroContent = {
  headline:
    "Bangun Brand Digital Anda Lebih Kuat & Terarah Bersama Dreams Marketing",
  subheadline:
    "Solusi Social Media Management, Creative Design, dan Digital Training untuk bisnis, UMKM, dan individu di era digital.",
  keyPoints: [
    "Strategi berbasis data & tren",
    "Tim profesional & berpengalaman",
    "Harga kompetitif & transparan",
  ],
  heroImage: "img/backgrounds/2.jpeg",
};

export const services = [
  {
    id: 1,
    title: "Social Media Management",
    description:
      "Kelola akun sosial media Anda dengan strategi konten yang tepat dan engagement maksimal.",
    features: [
      "Account management",
      "Content planning & calendar",
      "Engagement strategy",
      "Performance reporting",
    ],
    ctaText: "Kelola Sosial Media Saya",
    icon: "Share2",
  },
  {
    id: 2,
    title: "Graphic Design & Video Editing",
    description:
      "Konten visual berkualitas tinggi untuk meningkatkan daya tarik brand Anda di media sosial.",
    features: [
      "Feed & story design",
      "Branding visuals",
      "Short-form videos (Reels & TikTok)",
      "Professional editing",
    ],
    ctaText: "Lihat Portofolio",
    icon: "Palette",
  },
  {
    id: 3,
    title: "Digital Marketing Training",
    description:
      "Program pelatihan komprehensif untuk meningkatkan skill digital marketing Anda.",
    features: [
      "Program Diantosan",
      "Google Ads & SEO",
      "TikTok Marketing",
      "Power Closing",
      "Business Model Canvas",
    ],
    ctaText: "Daftar Pelatihan",
    icon: "GraduationCap",
  },
];

export const trialDemo = {
  title: "Coba Layanan Kami Selama 1 Bulan – Risiko Rendah, Hasil Nyata",
  subtitle:
    "Coba gratis 30 hari. Bayar hanya Rp 250.000 jika lanjut ke bulan berikutnya.",
  benefits: [
    "Real account handling (not simulation)",
    "Managed by professional team",
    "Performance evaluation at the end of trial",
  ],
  terms: [
    "Trial period: 1 month",
    "Service: Social Media Management",
    "Continue next month by paying only 50% of the package price",
    "No long-term contract",
  ],
};

export const diantosanProgram = {
  title: "Diantosan – Digital Marketing Goes To Pesantren",
  description:
    "Program edukasi digital marketing yang fokus pada pemberdayaan pesantren, UMKM, dan komunitas.",
  image: "img/backgrounds/1.jpeg",
};

export const visionMission = {
  vision:
    "Menjadi motor penggerak entrepreneurship berbasis Digital Marketing.",
  mission: [
    "Digital marketing training",
    "Building skilled digital communities",
    "Accelerating UMKM growth",
    "Expanding digital education through Diantosan",
  ],
};

export const team = [
  {
    id: 1,
    name: "Muhammad Farouq",
    position: "Chief Executive Officer",
    avatar:
      "https://ui-avatars.com/api/?name=Muhammad+Farouq&size=200&background=D32F2F&color=fff",
  },
  {
    id: 2,
    name: "Fera Farfalla",
    position: "Chief Marketing Officer",
    avatar:
      "https://ui-avatars.com/api/?name=Fera+Farfalla&size=200&background=D32F2F&color=fff",
  },
];

export const aboutImages = {
  workspace: "img/backgrounds/3.jpeg",
  creative: "https://images.unsplash.com/photo-1460925895917-afdab827c52f",
};

export const partnerLogos = [
  <img
    src="/img/logo/cineurasa.png"
    alt="Cineurasa"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,

  <img
    src="/img/logo/ppq.png"
    alt="PPQ"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,

  <img
    src="/img/logo/mimici.png"
    alt="Mimici Cake"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,

  <img
    src="/img/logo/jamu.png"
    alt="Jamu Gendong Putri"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,

  <img
    src="/img/logo/cendolin.png"
    alt="Rumah makan Cendolin"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
  <img
    src="/img/logo/wedding.png"
    alt="Wedding Nisa Syar'i"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
  <img
    src="/img/mitra/centhini-bakery.jpeg"
    alt="Centhini Bakery"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
  <img
    src="/img/mitra/furymaru.png"
    alt="Furymaru"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
  <img
    src="/img/mitra/hzhazu.jpeg"
    alt="Huzhazu"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
  <img
    src="/img/mitra/lapis-ajiieb.png"
    alt="Lapis Ajiieb"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
  <img
    src="/img/mitra/pamulang142.png"
    alt="Pamulang 142"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
  <img
    src="/img/mitra/risfood.png"
    alt="Risfood"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
  <img
    src="/img/mitra/teknoeni.png"
    alt="Tekn noeni"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,

  <img
    src="/img/mitra/tienoer-food.png"
    alt="Tienoer Food"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
  <img
    src="/img/mitra/win-house.jpeg"
    alt="Win House"
    className="object-contain w-auto transition-all duration-300 h-14 md:h-16 lg:h-18 grayscale hover:grayscale-0"
  />,
];
export const enhancedTestimonials = [
  {
    id: 1,
    name: "Cineurasa",
    position: "Brand Kuliner",
    text: "Desain feed Instagram kami naik kelas! Engagement meningkat drastis sejak pakai jasa Dreams Marketing.",
    rating: 5,
    avatar: "https://ui-avatars.com/api/?name=Cineurasa&background=D32F2F&color=fff",
    highlight: "Engagement meningkat drastis!"
  },
  {
    id: 2,
    name: "Jamu Gendong Putri",
    position: "UMKM Herbal",
    text: "Sangat membantu branding produk tradisional jadi lebih modern tanpa menghilangkan ciri khasnya.",
    rating: 5,
    avatar: "https://ui-avatars.com/api/?name=Jamu+Gendong&background=16a34a&color=fff",
    highlight: "Branding jadi modern!"
  },
  {
    id: 3,
    name: "Nisa Wedding Syar'i",
    position: "Wedding Service",
    text: "Klien banyak yang bilang IG kami sekarang rapi banget. Timnya juga responsif dan enak diajak diskusi.",
    rating: 4,
    avatar: "https://ui-avatars.com/api/?name=Nisa+Wedding&background=ea580c&color=fff",
    highlight: "Tim responsif & solutif"
  },
  {
    id: 4,
    name: "PPQ Nahwa Nur",
    position: "Pendidikan",
    text: "Pengelolaan medsos jadi gampang, kami bisa fokus ngurus santri. Syukran Dreams Marketing!",
    rating: 5,
    avatar: "https://ui-avatars.com/api/?name=PPQ+Nahwa&background=0891b2&color=fff",
    highlight: "Fokus ke pendidikan"
  },
  {
    id: 5,
    name: "Cendolin",
    position: "UMKM Kuliner",
    text: "Landing page yang dibuat sangat profesional. Konversi penjualan kami meningkat 40% bulan ini.",
    rating: 5,
    avatar: "https://ui-avatars.com/api/?name=Cendolin&background=ca8a04&color=fff",
    highlight: "Konversi naik 40%"
  },
];

export const clientFeed = [
  {
    id: 1,
    type: "new_project",
    client: "Cineurasa",
    message: "Memulai project rebranding visual Instagram",
    timestamp: "2 jam yang lalu",
    icon: "Palette"
  },
  {
    id: 2,
    type: "milestone",
    client: "Jamu Gendong Putri",
    message: "Mencapai 10.000 followers organik",
    timestamp: "5 jam yang lalu",
    icon: "TrendingUp"
  },
  {
    id: 3,
    type: "review",
    client: "Nisa Wedding",
    message: "Memberikan rating bintang 5 untuk layanan kami",
    timestamp: "1 hari yang lalu",
    icon: "Star"
  },
  {
    id: 4,
    type: "training",
    client: "Batch 4 Diantosan",
    message: "30 peserta lulus sertifikasi digital marketing",
    timestamp: "2 hari yang lalu",
    icon: "GraduationCap"
  },
  {
    id: 5,
    type: "new_project",
    client: "Tienoer Food",
    message: "Sign kontrak untuk Full Social Media Management",
    timestamp: "3 hari yang lalu",
    icon: "FileSignature"
  },
];

export const caseStudies = [
  // ==========================================
  // KATEGORI 1: BRANDING (PRODUCT PHOTOGRAPHY)
  // ==========================================
  // {
  //   id: 1,
  //   title: "Katalog Visual & Foto Produk Cineurasa",
  //   client: "Cineurasa",
  //   category: "Product Photography",
  //   categorySlug: "branding",
  //   challenge: "Menampilkan tekstur dan warna produk agar terlihat menggugah selera untuk kebutuhan katalog dan materi iklan.",
  //   solution: "Menggunakan teknik pencahayaan studio dengan properti minimalis untuk menonjolkan detail dan kualitas produk.",
  //   results: [
  //     { label: "Aset Visual", value: "20+ Foto" },
  //     { label: "Resolusi", value: "High-Res" },
  //   ],
  //   tags: ["Food Photography", "Styling", "Retouching"],
  //   thumbnail: "/images/branding/cineurasa/thumbnail.jpg",
  //   gallery: [
  //     "/images/branding/cineurasa/foto-1.jpg",
  //     "/images/branding/cineurasa/foto-2.jpg"
  //   ]
  // },
  // {
  //   id: 2,
  //   title: "Portfolio Gaun & Riasan Nisa Wedding",
  //   client: "Nisa Wedding Syar'i",
  //   category: "Visual Branding",
  //   categorySlug: "branding",
  //   challenge: "Mendokumentasikan detail gaun syar'i dan riasan dengan nuansa yang elegan namun tetap natural.",
  //   solution: "Sesi pemotretan editorial dengan konsep soft-lighting untuk menonjolkan keanggunan dan detail payet gaun.",
  //   results: [
  //     { label: "Lookbook", value: "15+ Looks" },
  //     { label: "Usage", value: "Brosur & IG" },
  //   ],
  //   tags: ["Wedding Photography", "Editorial", "Fashion"],
  //   thumbnail: "/images/branding/nisawedding/thumbnail.jpg",
  //   gallery: [
  //     "/images/branding/nisawedding/foto-1.jpg",
  //     "/images/branding/nisawedding/foto-2.jpg"
  //   ]
  // },
  {
    id: 3,
    title: "Visualisasi Menggugah Selera Lapis Ajiieb",
    client: "Lapis Ajiieb",
    category: "Product Photography",
    categorySlug: "branding",
    challenge: "Memperlihatkan detail lapisan kue yang presisi dan tekstur yang lembut agar audiens bisa 'merasakan' melalui foto.",
    solution: "Penataan komposisi (food styling) yang hangat dipadukan dengan properti minum teh untuk menciptakan suasana premium.",
    results: [
      { label: "Aset Visual", value: "12+ Foto" },
      { label: "Konsep", value: "Warm Tone" },
    ],
    tags: ["Food Photography", "Props Styling", "Commercial"],
    thumbnail: "/img/social-media/feed-lapis-ajiieb.jpg",
    gallery: [
      "/img/branding/lapisajiieb-1.jpg",
      "/img/branding/lapisajiieb-2.jpg"
    ]
  },
  // {
  //   id: 4,
  //   title: "Kesegaran Visual Minuman Cendolin",
  //   client: "Cendolin",
  //   category: "Product Photography",
  //   categorySlug: "branding",
  //   challenge: "Menangkap efek embun (condensation) pada gelas dan tekstur isian minuman agar terlihat sangat menyegarkan.",
  //   solution: "Pemotretan menggunakan teknik high-speed sync dan manipulasi pencahayaan untuk memberikan kesan dingin dan segar secara instan.",
  //   results: [
  //     { label: "Aset Visual", value: "18+ Foto" },
  //     { label: "Usage", value: "Menu & Poster" },
  //   ],
  //   tags: ["Beverage Photography", "Splash Effect", "Lighting"],
  //   thumbnail: "/images/branding/cendolin/thumbnail.jpg",
  //   gallery: [
  //     "/images/branding/cendolin/foto-1.jpg",
  //     "/images/branding/cendolin/foto-2.jpg"
  //   ]
  // },
  // {
  //   id: 5,
  //   title: "Rejuvenasi Visual Jamu Gendong Putri",
  //   client: "Jamu Gendong Putri",
  //   category: "Product Photography & Mockup",
  //   categorySlug: "branding",
  //   challenge: "Mengangkat citra minuman tradisional herbal menjadi produk yang terlihat modern, bersih, dan higienis.",
  //   solution: "Memadukan foto produk asli dengan pembuatan visual mockup berkualitas tinggi yang menonjolkan bahan-bahan alami.",
  //   results: [
  //     { label: "Aset Visual", value: "25+ Foto" },
  //     { label: "Vibe", value: "Modern Natural" },
  //   ],
  //   tags: ["Product Mockup", "Traditional Beverage", "Visual Editing"],
  //   thumbnail: "/images/branding/jamu-gendong-putri/thumbnail.jpg",
  //   gallery: [
  //     "/images/branding/jamu-gendong-putri/foto-1.jpg",
  //     "/images/branding/jamu-gendong-putri/foto-2.jpg"
  //   ]
  // },
  // {
  //   id: 6,
  //   title: "Komersialisasi Produk SAGUte Snack",
  //   client: "SAGUte Snack",
  //   category: "Product Photography & Mockup",
  //   categorySlug: "branding",
  //   challenge: "Membuat visual produk camilan dan desain kemasan terlihat menonjol di etalase digital maupun marketplace.",
  //   solution: "Menghasilkan foto produk beresolusi tinggi serta mengaplikasikan desain ke dalam mockup kemasan yang realistis.",
  //   results: [
  //     { label: "Aset Visual", value: "10+ Foto Utama" },
  //     { label: "Platform", value: "Marketplace & Ads" },
  //   ],
  //   tags: ["Snack Photography", "Packaging Mockup", "E-commerce"],
  //   thumbnail: "/images/branding/sagute-snack/thumbnail.jpg",
  //   gallery: [
  //     "/images/branding/sagute-snack/foto-1.jpg",
  //     "/images/branding/sagute-snack/foto-2.jpg"
  //   ]
  // },

  // ==========================================
  // KATEGORI 2: SOCIAL MEDIA (FEED & CONTENT)
  // ==========================================
  {
    id: 7,
    title: "Manajemen Feed Instagram Cineurasa",
    client: "Cineurasa",
    category: "Social Media Management",
    categorySlug: "social-media",
    challenge: "Menjaga konsistensi postingan dan interaksi audiens untuk membangun loyalitas pelanggan F&B.",
    solution: "Merancang desain template feed yang interaktif, informatif, dan menyusun kalender konten (content plan) yang terstruktur.",
    results: [
      { label: "Engagement", value: "+45%" },
      { label: "Postingan", value: "30/Bulan" },
    ],
    tags: ["Content Plan", "Instagram Grid", "F&B Marketing"],
    thumbnail: "/img/social-media/feed-cineurasa.jpg",
    gallery: [
      "/img/branding/foto-cineurasa.jpg",
      "/img/branding/foto-cineurasa.jpg"
    ]
  },
  {
    id: 8,
    title: "Edukasi & Dakwah Digital PPQ",
    client: "PPQ",
    category: "Social Media Management",
    categorySlug: "social-media",
    challenge: "Menyampaikan informasi program dan konten dakwah agar mudah dipahami dan menarik bagi audiens generasi muda.",
    solution: "Membuat desain carousel edukatif (micro-blogging) dengan visual yang clean, modern, dan bernuansa islami.",
    results: [
      { label: "Reach", value: "2x Lipat" },
      { label: "Shares", value: "Tinggi" },
    ],
    tags: ["Micro-blogging", "Islamic Content", "Carousel Design"],
    thumbnail: "/img/social-media/feed-ppq.jpg",
    gallery: [
      "/img/branding/ppq-1.jpg",
      "/img/branding/ppq-2.jpg"
    ]
  },
  {
    id: 9,
    title: "Visual Aesthetic Feed Mimici Cake",
    client: "Mimici Cake",
    category: "Social Media Management",
    categorySlug: "social-media",
    challenge: "Menonjolkan tampilan kue yang cantik sekaligus menginformasikan promo harian tanpa merusak estetika feed.",
    solution: "Menerapkan konsep warna pastel yang manis dipadukan dengan template Instagram Story yang interaktif untuk kebutuhan promo.",
    results: [
      { label: "Followers", value: "+1.2K" },
      { label: "Click Rate", value: "Meningkat" },
    ],
    tags: ["Feed Aesthetic", "Promo Template", "Bakery"],
    thumbnail: "/img/social-media/feed-mimici-cake.jpg",
    gallery: [
     "img/branding/mimici-cake.jpg",
     "img/branding/mimici-cake-2.jpg",
     "img/branding/mimici-cake-3.jpg"
    ]
  },
  {
    id: 10,
    title: "Social Media Branding Rumah Cendolin",
    client: "Rumah Cendolin",
    category: "Social Media Management",
    categorySlug: "social-media",
    challenge: "Meningkatkan brand awareness minuman tradisional di kalangan anak muda yang aktif di media sosial.",
    solution: "Menciptakan desain feed bergaya pop-culture yang segar dan ceria, serta adaptasi template untuk konten video pendek (Reels/TikTok).",
    results: [
      { label: "Brand Awareness", value: "Naik" },
      { label: "Interaksi", value: "Aktif" },
    ],
    tags: ["Pop-culture Design", "Brand Awareness", "Content Creation"],
    thumbnail: "/img/social-media/feed-cendolin.jpg",
    gallery: [
      "/img/branding/cendolin.jpg",
      "/img/branding/cendolin-1.jpg",
      "/img/branding/cendolin-2.jpg",
      "/img/branding/cendolin-3.jpg"
    ]
  },
  {
    id: 11,
    title: "Perencanaan Konten Nisa Wedding Syar'i",
    client: "Nisa Wedding Syar'i",
    category: "Social Media Management",
    categorySlug: "social-media",
    challenge: "Menarik calon pengantin melalui portofolio gaun dan layanan rias yang tersusun rapi di profil Instagram.",
    solution: "Penataan grid layaknya majalah (magazine style) dan pembuatan cover highlight stories yang elegan untuk memisahkan katalog gaun & pricelist.",
    results: [
      { label: "Profile Visits", value: "+60%" },
      { label: "Leads", value: "Konsisten" },
    ],
    tags: ["Grid Layout", "Wedding Planner", "Story Highlight"],
    thumbnail: "/img/social-media/feed-nisa-wedding.jpg",
    gallery: [
      "/img/branding/nisa-wedding-1.jpg",
      "/img/branding/nisa-wedding-2.jpg",
      "/img/branding/nisa-wedding-3.jpg",
      "/img/branding/nisa-wedding-4.jpg",
      "/img/branding/nisa-wedding-5.jpg",
      "/img/branding/nisa-wedding-6.jpg",
      "/img/branding/nisa-wedding-7.jpg",
      "/img/branding/nisa-wedding-8.jpg"
    ]
  },
  {
    id: 12,
    title: "Gayatri Food",
    client: "Jamu Gendong Putri & Sagute Snack",
    category: "Social Media Management",
    categorySlug: "social-media",
    challenge: "Mengoptimalkan visibilitas produk gayatri food di media sosial untuk meningkatkan penjualan.",
    solution: "visibilitas produk gayatri food di media sosial untuk meningkatkan penjualan.",
    results: [
      { label: "Profile Visits", value: "+60%" },
      { label: "Leads", value: "Konsisten" },
    ],
    tags: ["Social Media Management", "Social Media Marketing", "Social Media Ads"],
    thumbnail: "/img/social-media/feed-gayatri.jpg",
    gallery: [
      "/img/branding/gayatri-food-1.jpg",
      "/img/branding/gayatri-food-2.jpg",
      "/img/branding/gayatri-food-3.jpg"
    ]
  },
  
];